<template>
  <div>
    <b-modal :visible="isLoginModalOpen" centered lazy @hide="hide" footer-bg-variant="light">
      <template slot="modal-header">
        <div class="container text-center w-100 mt-2">
          <h5 class="fa fa-times float-right" @click="hide" />
          <h5>{{ $t('MODAL_login_title') }}</h5>
        </div>
      </template>

      <template slot="modal-footer">
        <div class="container my-3">
          <div class="row">
            <div class="col text-center">
              <p>{{ $t('MODAL_login_footer_register') }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <b-button
                variant="outline-secondary"
                class="w-100"
                @click="signup"
              >{{ $t('MODAL_login_register_button') }}</b-button>
            </div>
          </div>
        </div>
      </template>

      <b-form @submit.prevent="login" class="container">
        <div class="row">
          <div class="col">
            <div v-if="error" class="alert alert-danger" role="alert">
              <small>{{ $t('MODAL_login_error_message') }}</small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div role="group" class="w-100">
              <b-form-input
                type="email"
                name="username"
                id="id_username"
                aria-describedby="emailHelp"
                :state="loginTried && emailInvalid ? false : null"
                :placeholder="$t('emailaddress')"
                v-model="email"
                required
              />
              <b-form-feedback id="input-feedback">
                {{ $t('MODAL_login_enter_valid_email') }}
                <small>(hans.muster@bechterew.ch)</small>
              </b-form-feedback>
            </div>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col">
            <div role="group" class="w-100">
              <b-form-input
                type="password"
                class="form-control"
                name="password"
                id="id_password"
                :state="loginTried && passwordInvalid ? false : null"
                :placeholder="$t('password')"
                v-model="password"
                required
              />
              <b-form-feedback id="input-feedback">{{ $t('MODAL_login_error_pw') }}</b-form-feedback>
            </div>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col">
            <b-button
              :disabled="
                (loginTried && (emailInvalid || passwordInvalid)) || pending
              "
              type="submit"
              variant="primary"
              class="w-100"
            >
              <span v-if="pending">
                <loader />
              </span>
              <span v-else>{{ $t('MODAL_login_login_button') }}</span>
            </b-button>
          </div>
        </div>
      </b-form>
      <div class="row">
        <div class="col text-center">
          <p>
            <small>
              <router-link
                class="text-secondary"
                tag="a"
                :to="{ name: 'reset-password' }"
              >{{ $t('MODAL_login_forgot_password') }}</router-link>
            </small>
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import Loader from '@/components/Loader';

export default {
  name: 'login-modal',
  components: { Loader },
  computed: {
    ...mapState(['isLoginModalOpen']),
    ...mapState({
      pending: state => state.api.pending.user,
      error: state => state.api.error.user,
    }),
    emailInvalid() {
      return !/.*@.*\..*/.test(this.email);
    },
    passwordInvalid() {
      return !this.password;
    },
  },
  data() {
    return {
      loginTried: false,
      email: '',
      password: '',
    };
  },
  methods: {
    hide() {
      this.loginTried = false;
      this.email = null;
      this.password = null;
      this.$store.dispatch('closeLoginModal');
    },
    signup() {
      this.$store.dispatch('closeLoginModal');
      this.$router.push({ name: 'signup' });
    },
    login() {
      this.loginTried = true;

      if (!this.emailInvalid && !this.passwordInvalid)
        this.$store.dispatch('login', {
          email: this.email,
          password: this.password,
        });
    },
  },
};
</script>

<style scoped>
.maxW500 {
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/Login.vue